module.exports = __webpack_public_path__ + "static/media/3DPPA30.990c2919.jpg";